module.exports = __webpack_public_path__ + "static/media/warehouse.6dd9269d.gif";